import compose from "../../utils/compose";
import { militaryTime } from "../../utils/time";

function validTime(time) {
  return time && !isNaN(Number(time.hour)) && time.hour > 0;
}

function validTimes(times) {
  return times.filter(validTime);
}

function sortedTime(a, b) {
  return militaryTime(a) - militaryTime(b);
}

function sortedTimes(times) {
  return times.sort(sortedTime);
}

export default compose(
  validTimes,
  sortedTimes
);



// WEBPACK FOOTER //
// ./src/components/TimeSelect/selectedTimes.js